document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('homepage-gradient')) return;

  const bar = document.querySelector('.announcement-bar-section');
  if (!bar) return;

  const root = document.documentElement;
  let barHeight = 0;
  let ticking = false;

  const applyOffset = () => {
    ticking = false;
    const offset = Math.max(0, barHeight - window.scrollY);
    root.style.setProperty('--announcement-offset', `${offset}px`);
  };

  const requestOffset = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(applyOffset);
  };

  const measure = () => {
    barHeight = bar.offsetHeight;
    applyOffset();
  };

  measure();

  window.addEventListener('scroll', requestOffset, { passive: true });
  window.addEventListener('resize', measure);

  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(bar);
});
